import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetPurchaseProductReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
import { getVendorData } from "../Vendor/Vendor.action";
import _ from "lodash";
import Swal from "sweetalert";
import moment from "moment";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import SelectorField from "../../../components/SelectorField";
import DateField from "../../../components/DateField";
import "./Report.css";


const PurchaseProductReport = (props) => {
    const [startDate, setStartDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [vendorId, setVendorId] = useState("");
    const [vendorName, setVendorName] = useState("");
    const isDisabled = _.isEmpty(startDate) || _.isEmpty(endDate) || _.isEmpty(vendorId) || props.isFetchingPurchaseProductReport;

    const handleDangerVisible = () => {
        Swal({
            title: "Error",
            text: "Something went wrong!",
            icon: "error",
            button: "Ok",
        });
    };

    const GenratePDF = () => {
        props.GetPurchaseProductReportApi({
            startDate: startDate,
            endDate: endDate,
            vendorId,
            vendorName,
        },
            handleDangerVisible,
        );
    };

    const handleChangeVendor = (selectedOption) => {
        if (!selectedOption) {
            setVendorId("");
            setVendorName("");
            return;
        }
        setVendorId(selectedOption.value);
        setVendorName(selectedOption.label);
    };
    const vendorList = _.isEmpty(props.vendorDataList) ? [] : props.vendorDataList.map((x) => {
        let data = {
            value: x._id,
            label: x.vendorName,
        };
        return data;
    });

    useEffect(() => {
        props.getVendorData();
    }, []);

    return (
        <>
            <SinglePageDashboard header="Purchase Product Report" />

            <div className="page-container">
                <div className="breadcrumb">
                    <Link to="/home" className="breadcrumb-link">Home</Link>
                    <ChevronRightIcon />
                    <Link to="/report" className="breadcrumb-link">Reports</Link>
                    <ChevronRightIcon />
                    <span className="breadcrumb-current">Purchase Product Report</span>
                </div>

                <div className="page-header">
                    <h1 className="page-title">Purchase Product Report</h1>
                </div>

                <GlobalFormCard
                    title="Select Date"
                    subtitle="Report will be generated for this date"
                    icon={<CalendarIcon />}
                    maxWidth="900px"
                >
                    <DateField
                        label='Start Date'
                        value={startDate}
                        onChange={setStartDate}
                    />

                    <DateField
                        label='End Date'
                        value={endDate}
                        onChange={setEndDate}
                    />

                    <SelectorField
                        options={vendorList}
                        value={vendorId}
                        onChange={handleChangeVendor}
                        isDisabled={false}
                        isLoading={props.isFetchingVendor}
                        label="Select Vendor"
                    />

                    <div className="divider" />

                    <button
                        onClick={GenratePDF}
                        disabled={isDisabled}
                        className={`generate-btn ${isDisabled ? "disabled" : ""}`}
                    >
                        {props.isFetchingPurchaseProductReport ? (
                            <>
                                <span className="spinner" />
                                Generating…
                            </>
                        ) : (
                            <>
                                <DownloadIcon />
                                Generate Report
                            </>
                        )}
                    </button>

                    <p className="footer-text">Report will be downloaded as a PDF file</p>

                </GlobalFormCard>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetPurchaseProductReportApi: (payload, handleDangerVisible) => dispatch(GetPurchaseProductReportApi(payload, handleDangerVisible)),
    getVendorData: () => dispatch(getVendorData()),
});

const mapStateToProps = (state) => ({
    isFetchingPurchaseProductReport: state.ReportReducer.isFetchingPurchaseProductReport,
    purchaseProductReportData: state.ReportReducer.purchaseProductReportData,
    isFetchingVendor: state.VendorReducer.isFetchingVendor,
    vendorDataList: state.VendorReducer.vendorDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseProductReport);